import React from 'react';
import PropTypes from 'prop-types';
import { BundleRoute } from '@saucelabs/sl-component-router';
import dynamic from '@redux-dynostore/react-redux';
import { attachReducer } from '@redux-dynostore/core';
import { SentryBoundary } from '@saucelabs/sl-component-sentry';
import { constants as sentryConstants } from '@saucelabs/sl-util-sentry';

import invitationsReducer from './reducers';

const importInvitationRoutes = () => import(/* webpackChunkName: "invitations" */ './containers/InvitationContainer');

const InvitationRoutes = ({ match }) => (
  <SentryBoundary owner={sentryConstants.TEAMS.IAM}>
    <BundleRoute
      load={importInvitationRoutes}
      path={`${match.url}/:invitationToken`}
    />
  </SentryBoundary>
);

InvitationRoutes.propTypes = {
  match: PropTypes.object.isRequired,
};

export default dynamic(
  'apps.invitations', attachReducer(invitationsReducer),
)(InvitationRoutes);
